import React from 'react';
import { Portal } from '@chakra-ui/react';

const ModalBgLayout = ({ 
  children,
  className = 'p-6',  
  maxWidth = 'max-w-xl',
}) => {
  return (
    <Portal>
      <div className="fixed overflow-auto inset-0 left-0 top-0 w-full h-full flex items-center justify-center z-50 bg-black bg-opacity-50">
        {/* wrapper */}
        <div
          className={`fixed mobile:inset-0 p-4 mobile:p-0 mobile:max-w-none ${maxWidth}`}
        >
          <div className='bg-white w-full rounded-lg shadow-xl mobile:h-[100vh] mobile:rounded-none mobile:overflow-scroll overflow-hidden'>
            {/* Children */}
            <div className={`flex h-full ${className}`}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default ModalBgLayout;
